import { render, staticRenderFns } from "./choicePeopleInput.vue?vue&type=template&id=62f97911&scoped=true&"
import script from "./choicePeopleInput.vue?vue&type=script&lang=js&"
export * from "./choicePeopleInput.vue?vue&type=script&lang=js&"
import style0 from "./choicePeopleInput.vue?vue&type=style&index=0&id=62f97911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f97911",
  null
  
)

export default component.exports